import React from 'react';
import { Link } from "react-router-dom";
import { Auth } from 'aws-amplify';
import * as MESSAGES from '../Lib/Messages';
import Spinner from './Spinner';
import Notification from './Notification';
import Validator from '../Lib/Validator';

class UserCompleteNewPass extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			loading: false,
			errors: {},
            isError: false,
		};

        this.state = {...this.getInitialState(), ...this.state};
		this.handleChange = this.handleChange.bind(this);
		this.clearForm = this.clearForm.bind(this);
	}

    getInitialState = () => ({
        user: {
			name: '',
            new_password: '',
            confirm_password: '',
        },
	});

    clearForm = () => {
		this.setState(this.getInitialState());
	}

	handleChange(event) {
        const { target: { name, value } } = event;
		const { user, errors } = this.state;

		user[name] = value;
        this.setState({ user });

		if(errors[name]) {
			delete errors[name];
		}
	}

	isValidation() {
		const { user } = this.state;
		this.setState({errors: {}, errorMessage: ''});

		var errors = {};
		var isError = false;
		var validator = new Validator();

		if(!validator.required(user.name)) {
			errors['name'] = MESSAGES.ERROR_REQUIRED;
			isError = true;
		}
		if(!validator.required(user.new_password)) {
			errors['new_password'] = MESSAGES.ERROR_REQUIRED;
			isError = true;
		} else if(!validator.minLength(user.new_password, 8)) {
			errors['new_password'] = MESSAGES.ERROR_MINLENGTH;
			isError = true;
		}
		if(!validator.required(user.confirm_password)) {
			errors['confirm_password'] = MESSAGES.ERROR_REQUIRED;
			isError = true;
		} else if(!validator.match(user.new_password, user.confirm_password)) {
			errors['confirm_password'] = MESSAGES.ERROR_CONFIRM_PASS;
			isError = true;
		}

		if(isError) {
			this.setState({ errors });
			return false;
		}

		return true;
	}

	handleSave = async (e) => {
		e.stopPropagation();
		e.preventDefault();

		if(!this.isValidation()) {
			return false;
		}

		const { history } = this.props;
		const { user } = this.state;

        this.setState({ loading: true });

        let userCognito = localStorage.getItem("AuthChangePass");
		console.log(userCognito);
		console.log(user.name);
        Auth.completeNewPassword(userCognito, user.new_password, { name: user.name })
        .then(user => {
			console.log(user);
            localStorage.clear();
            this.clearForm();
            this.setState({errorMessage: MESSAGES.SUCCESS_RESET_PASSWORD, isError: false});
            setTimeout(function() {
                history.push('/user/signin');
            }, 2000);
        })
        .catch(err => {
			console.log(err);
            if(err.message) {
              this.setState({errorMessage: err.message, isError: true});
            }
        });

        this.setState({ loading: false });
	}

    componentDidMount() {
        let userCognito = localStorage.getItem("AuthChangePass");
        if(!userCognito) {
            this.props.history.push('/user/signin');
        }
	}

	render() {
		const { loading, user, errors, isError, errorMessage } = this.state;
		return (
			<div className="center-sign">
				<div className="panel card-sign">
					<div className="card-title-sign mt-3 text-right">
						<h2 className="title text-uppercase font-weight-bold m-0"><i className="fa fa-user mr-1"></i> Change Password</h2>
					</div>
                    <div className={`card-body${loading ? ' loading-overlay-showing' : ''}`}>
                        <Spinner />
						<form method="POST">
							<Notification isError={isError} message={errorMessage} />

							<div className={`form-group mb-3 ${errors.name ? 'has-danger' : null}`}>
								<label className="float-left">Name</label>
								<div className="input-group input-group-icon">
									<input
										  name="name" type="text"
										  className="form-control form-control-lg"
										  value={user.name}
										  onChange={this.handleChange}
									  />
									<span className="input-group-addon">
										<span className="icon icon-lg">
											<i className="fa fa-address-book"></i>
										</span>
									</span>
								</div>
								{errors.name ? (<label className="error">{errors.name}</label>) : (null)}
							</div>

							<div className={`form-group mb-3 ${errors.new_password ? 'has-danger' : null}`}>
                				<label className="float-left">New Password</label>
								<div className="input-group input-group-icon">
									<input
					                      name="new_password" type="password"
					                      className="form-control form-control-lg"
					                      value={user.new_password}
					                      onChange={this.handleChange}
					                  />
									<span className="input-group-addon">
										<span className="icon icon-lg">
											<i className="fa fa-lock"></i>
										</span>
									</span>
								</div>
								{errors.new_password ? (<label className="error">{errors.new_password}</label>) : (null)}
							</div>

							<div className={`form-group mb-3 ${errors.confirm_password ? 'has-danger' : null}`}>
                				<label className="float-left">Confirm Password</label>
								<div className="input-group input-group-icon">
									<input
					                      name="confirm_password" type="password"
					                      className="form-control form-control-lg"
					                      value={user.confirm_password}
					                      onChange={this.handleChange}
					                  />
									<span className="input-group-addon">
										<span className="icon icon-lg">
											<i className="fa fa-lock"></i>
										</span>
									</span>
								</div>
								{errors.confirm_password ? (<label className="error">{errors.confirm_password}</label>) : (null)}
							</div>

							<div className="row">
								<div className="col-sm-8">
								</div>
								<div className="col-sm-4 text-right">
                                    <button type="submit" className="btn btn-primary mt-2" onClick={this.handleSave} style={{ marginRight: 0}}>Confirm</button>
								</div>
							</div>
							<br />

              				<p className="text-center mt-3">Remembered? <Link role="menuitem" tabIndex="-1" to="/user/signin">Sign In!</Link></p>
						</form>
					</div>
				</div>

				<p className="text-center text-muted mt-3 mb-3">&copy; Copyright 2018. All Rights Reserved.</p>
			</div>
		)
	}
}

export default UserCompleteNewPass;
